module.exports = __webpack_public_path__ + "img/deco-3.68ca2f1a.svg";